import React from "react";

const BookmarkIcon = ({ width, fill, height }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 15 20" fill={fill}>
      <path
        d="M1.01506 1.48822C0.583664 1.91962 0.341309 2.5047 0.341309 3.11481V18.642C0.34137 18.746 0.369629 18.8481 0.423096 18.9373C0.476578 19.0266 0.553238 19.0996 0.644958 19.1487C0.736664 19.1978 0.839966 19.2211 0.943863 19.2161C1.04778 19.2112 1.14839 19.1781 1.23499 19.1205L7.24229 15.8828L13.2496 19.1205C13.3362 19.1781 13.4368 19.2112 13.5407 19.2161C13.6446 19.2211 13.7479 19.1978 13.8396 19.1487C13.9313 19.0996 14.008 19.0266 14.0615 18.9373C14.115 18.8481 14.1432 18.746 14.1433 18.642V3.11481C14.1433 2.5047 13.9009 1.91962 13.4695 1.48822C13.0381 1.05682 12.453 0.814453 11.843 0.814453H2.64163C2.03156 0.814453 1.44646 1.05682 1.01506 1.48822Z"
        fill="black"
      />
    </svg>
  );
};

BookmarkIcon.defaultProps = {
  width: 15,
  height: 20,
  fill: "black",
};

export default BookmarkIcon;
